@file:OptIn(InternalResourceApi::class)

package devicehub.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/devicehub.composeapp.generated.resources/"

@delegate:ResourceContentHash(470_159_096)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(518_414_553)
internal val Res.drawable.login_backgroun: DrawableResource by lazy {
      DrawableResource("drawable:login_backgroun", setOf(
        ResourceItem(setOf(), "${MD}drawable/login_backgroun.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_607_161_223)
internal val Res.drawable.loging_background2: DrawableResource by lazy {
      DrawableResource("drawable:loging_background2", setOf(
        ResourceItem(setOf(), "${MD}drawable/loging_background2.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(814_950_004)
internal val Res.drawable.vreo_logo: DrawableResource by lazy {
      DrawableResource("drawable:vreo_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/vreo_logo.jpg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("login_backgroun", Res.drawable.login_backgroun)
  map.put("loging_background2", Res.drawable.loging_background2)
  map.put("vreo_logo", Res.drawable.vreo_logo)
}
